module.exports = __webpack_public_path__ + "img/watercolor.6ecf97a7.png";